function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/reactive-element.js";
import { nothing as d, html as u } from "../../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/lit-html.js";
import "../../../../node_modules/.pnpm/lit-element@4.2.1/node_modules/lit-element/lit-element.js";
import { customElement as b } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as r } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/property.js";
import { classMap as m } from "../../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/directives/class-map.js";
import g from "../../../../packages/web-components/src/components/guided-nav/gator/guided-nav-substep/guided-nav-substep.gator.scss.js";
import h from "../../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import v from "../../../../packages/web-components/src/tokens/semantic.tokens.scss.js";
import { NgcListItem as f } from "../../../list/gator/list-item/list-item.gator.js";
import { unsafeCSS as c } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/css-tag.js";
var y = Object.defineProperty,
  _ = Object.getOwnPropertyDescriptor,
  s = function s(p, o, n, i) {
    for (var t = i > 1 ? void 0 : i ? _(o, n) : o, a = p.length - 1, l; a >= 0; a--) (l = p[a]) && (t = (i ? l(o, n, t) : l(t)) || t);
    return i && t && y(o, n, t), t;
  };
var e = /*#__PURE__*/function (_f) {
  function e() {
    var _this;
    _classCallCheck(this, e);
    _this = _callSuper(this, e, arguments), _this.substep = {
      id: "",
      value: "",
      text: "",
      complete: !1
    }, _this.selected = !1, _this.state = "complete", _this.onSubstepSelected = function () {};
    return _this;
  }
  _inherits(e, _f);
  return _createClass(e, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return u(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div class=\"", "\" role=\"listitem\">\n                <ngc-list-item\n                    class=", "\n                    text=\"", "\"\n                    .value=\"", "\"\n                    tabindex=\"0\"\n                    hide-checkmark\n                    ?selected=\"", "\"\n                    selectable\n                    @selected=\"", "\"\n                >\n                    ", "\n                </ngc-list-item>\n            </div>\n        "])), m(this._substepClasses), m(this._substepListItemClasses), this.substep.text, this.substep.value, this.selected, function (p) {
        return _this2.onSubstepSelected(p, _this2.substep);
      }, this.badgeContent ? u(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<ngc-badge slot=\"end\">", "</ngc-badge>"])), this.badgeContent) : d);
    }
  }, {
    key: "_substepClasses",
    get: function get() {
      return {
        "ngc-guided-nav-substep": !0,
        "ngc-guided-nav-substep-selected": this.selected
      };
    }
  }, {
    key: "_substepListItemClasses",
    get: function get() {
      return {
        "ngc-guided-nav-substep-complete": this.state === "complete",
        "ngc-guided-nav-substep-current": this.state === "current"
      };
    }
  }]);
}(f);
e.styles = [c(h), c(v), c(g)];
s([r()], e.prototype, "substep", 2);
s([r({
  type: Boolean
})], e.prototype, "selected", 2);
s([r()], e.prototype, "state", 2);
s([r()], e.prototype, "badgeContent", 2);
s([r({
  type: Function
})], e.prototype, "onSubstepSelected", 2);
e = s([b("ngc-guided-nav-substep")], e);
export { e as NgcGuidedNavSubstep };